import {SortOrder} from "./SortOrder";
import {StringKeyOf} from "../type/Types";

export type SortOrderElement<T> = {
    name: StringKeyOf<T>
    order: SortOrder
}

// eslint-disable-next-line @typescript-eslint/no-redeclare
export namespace SortOrderElement {
    export function stringify<T>(element: SortOrderElement<T>): string {
        return `order=${element.name}:${element.order}`
    }

    export function join<T>(elements: SortOrderElement<T>[]): string {
        return elements.map(stringify).join()
    }
}